<v-app>
  <v-main>
    <div class="n-h-100 n-flex n-flex-column">
      <BreadCrumb />
    
      <div class="n-flex-grow">
        <router-view />
      </div>
    </div>
  </v-main>
</v-app>